export default __webpack_public_path__ + "static/media/CIA-Objection-Request-POPI-Form.7ba9619a.pdf";